import { render } from "./genFormModal.vue?vue&type=template&id=e2975f22&scoped=true"
import script from "./genFormModal.vue?vue&type=script&lang=js"
export * from "./genFormModal.vue?vue&type=script&lang=js"

import "./genFormModal.vue?vue&type=style&index=0&id=e2975f22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2975f22"]])

export default __exports__